module.exports = __webpack_public_path__ + "static/media/white-bathroom-banner.68f8a27d.jpg";